import React, { Suspense, useState, useRef } from "react";
import useIntersectionObserver from "./useIntersectionObserver";

const LazyLoadComponent = ({ children, animationClass, forceLoad = false }) => {
  const [isVisible, setIsVisible] = useState(false);
  const containerRef = useRef(null);

  useIntersectionObserver(
    containerRef,
    { threshold: 1 },
    (isIntersecting) => {
      if ((isIntersecting || forceLoad) && !isVisible) {
        setIsVisible(true);
      }
    },
    forceLoad // Передаем forceLoad в хук
  );

  return (
    <div ref={containerRef}>
      {isVisible ? (
        <div className={animationClass}>
          <Suspense fallback={<div>Loading...</div>}>{children}</Suspense>
        </div>
      ) : null}
    </div>
  );
};

export default LazyLoadComponent;
